

















































import { Component, Vue } from 'vue-property-decorator'
import FooterEntry from '~components/footer/FooterEntry.vue'
import { Menu, MenuItem } from '~base/common/types'
import { flatListToHierarchical } from '~plugins/utils'

@Component<Footer>({
  components: {
    FooterEntry,
  },
  apollo: {
    menu: {
      query: require('~base/graphql/queries/GetMenuByName.gql'),
      variables: {
        id: 'Footer',
      },
      result({ data }) {
        try {
          this.menuItems = flatListToHierarchical(data.menu.menuItems.nodes)
        } catch (e) {
          console.error(e)
        }
      },
    },
  },
})
export default class Footer extends Vue {
  private menu: Menu = { menuItems: { nodes: [] } }
  private menuItems: MenuItem[] = []
}
